const ukRules = new Intl.PluralRules("uk-UA");
const enRules = new Intl.PluralRules("en-GB");

/** Ukrainian noun form for a count: 1 крок, 2 кроки, 5 кроків. */
export function ukPlural(count: number, one: string, few: string, many: string): string {
  const rule = ukRules.select(count);
  if (rule === "one") return one;
  if (rule === "few") return few;
  if (rule === "many") return many;
  return few;
}

/** English noun form for a count: 1 step, 2 steps. */
export function enPlural(count: number, one: string, other: string): string {
  return enRules.select(count) === "one" ? one : other;
}
